var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutocompleteCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.773 31.603H22.227c-5.76 0-10.445-4.686-10.445-10.444s4.686-10.445 10.445-10.445h55.547c5.76 0 10.445 4.686 10.445 10.445s-4.686 10.444-10.445 10.444Zm-55.546-17.89c-4.105 0-7.445 3.34-7.445 7.445s3.34 7.444 7.445 7.444h55.547c4.105 0 7.445-3.34 7.445-7.444s-3.34-7.445-7.445-7.445H22.227Zm56.31 75.574H21.463c-5.339 0-9.682-4.343-9.682-9.682V47.753c0-5.338 4.343-9.681 9.682-9.681h57.074c5.339 0 9.682 4.343 9.682 9.681v31.852c0 5.339-4.343 9.682-9.682 9.682ZM21.463 41.073a6.689 6.689 0 0 0-6.682 6.681v31.852a6.689 6.689 0 0 0 6.682 6.682h57.074a6.689 6.689 0 0 0 6.682-6.682V47.754a6.689 6.689 0 0 0-6.682-6.681H21.463Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.307 19.953h21.571v3H21.307zm0 29.551h35.755v3H21.307zm0 11.676h54.179v3H21.307zm0 11.752H50v3H21.307zM69.37 56.865l-5.982-5.982 2.121-2.121 3.861 3.861 6.913-6.913 2.121 2.121-9.034 9.034z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutocompleteCheck);
export default __webpack_public_path__ + "static/media/autocomplete-check.d872b6db3a237d9e1c31725fc739500c.svg";
export { ForwardRef as ReactComponent };